import React, { useEffect } from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  PaginateCompaniesState,
} from "store/ducks/settings/companies";

import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";
import * as S from "./styles";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridCompanies, FilterCompanies } from "components/settings";
import { useFilters } from 'hooks/useFilters';

export const ListCompanies: React.FC = () => {
  const { getTranslation } = useTranslation(translations);
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  
  const { getData } = useFilters('companies')

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateCompanies
  ) as PaginateCompaniesState;

  useEffect(() => {
    getData();
  }, [getData]);
  
  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")}
          <MenuSelector page="companies" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission("insertCompany") && (
            <S.ButtonMini onClick={() => history.push("/settings/company/new")}>
              {getTranslation("novoCentro")}
            </S.ButtonMini>
          )}
          <FilterCompanies />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridCompanies companies={data} />
        <Paginator
          pagination={pagination}
          settingsPage='companies'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
